import React, {
	Component,
	PropTypes
}
from 'react';
import {
    Link
} from "react-router";
import {getUserId,resultTip,errToSuc,errorShow,successShow,language} from "UTIL/common"
import bumpService from 'SERVICES/purifier/bump/bumpService'
import FormInput from 'CONFIG/component/form/formInput'
import Tip from 'CONFIG/component/tip'
import BoxHeader from "CONFIG/component/boxHeaderCreate"
export default class DvcTypeCreate extends Component {
	constructor(props) {
		super(props);
		this.submit = this.submit.bind(this);
		this.state = {
			url: this.props.params.url,
		}
	}
	submit(event) {
		errToSuc();
        event.preventDefault();
        const name = $.trim($('#name').val());
        const arr = {
            "name": name,
        }
        var errorMessage = '';
        for(let i in arr){
            if(arr[i] == ''){
                errorShow(i);
            }
		}
		if($("[name='error']").length == 0){
            var data = JSON.stringify(arr);
            bumpService.dvcTypeInsertOrUpdate({data}).then(msg => {
                resultTip(msg,'/config/dvctype/dvctypeIndex')
            })
		}

	}
	render() {
		return (
			<div>
			   	<section className="content-header">
					<h1> {language()['ModelCategory']} <small>{language()['ModelCategoryAdd']}</small> </h1>
				</section>
				<section className="content" >
					<div className="box box-primary color-palette-box">
						<BoxHeader name={language()['ModelCategoryAdd']}/>
						<div className="box-body">
							<Tip ids=""/>
							<form className="form-horizontal">
								<FormInput id="name" name="CategoryName"/>
							</form>
						</div>
						<div className="box-footer">
							<div className="col-xs-2"></div>
							<div className="col-xs-1 text-center">
								<Link  to = "/config/dvctype/dvctypeIndex" className="btn btn-default btn-md">
									{language()['return']}
								</Link>
							</div>
							<div className="col-xs-1 text-center">
								<button className="btn btn-success" id="btnSubmit" onClick={this.submit.bind(this)}>{language()['submit']}</button>
							</div>
						</div>
					</div>
				</section>
		 </div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/bump/config/dvctype/dvctypeCreate.js